import React, { Component } from 'react';
import { InstantSearch, Hits, Configure, Index } from 'react-instantsearch/dom';
import PropTypes from 'prop-types';

import {
  connectStateResults,
  connectSearchBox
} from 'react-instantsearch/connectors';
import { each } from 'lodash';

import SearchBox from './SearchBox';
import Actor from './Actor';
import Network from './Network';
import Show from './Show';
import Movie from './Movie';

import './SearchBar.css';
const CustomSearchBox = connectSearchBox(SearchBox);
const IndexResults = connectStateResults(({ searchResults, children }) =>
  searchResults && searchResults.nbHits !== 0 ? children : null
);

class SearchBar extends Component {
  constructor(props) {
    super(props);

    this.state = { currentSearch: '' };
    this.selectedHitIndex = -1;
    this.resultItems = [];

    this.allowedMovies = this.props.allowedPages.includes('/movies');
    this.allowedShows = this.props.allowedPages.includes('/shows');
    this.allowedActors = this.props.allowedPages.includes('/actors');
    this.allowedNetworks = this.props.allowedPages.includes('/networks');

    this.clearSearch = this.clearSearch.bind(this);
    this.setWrapperRef = this.setWrapperRef.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  setWrapperRef(node) {
    this.wrapperRef = node;
  }

  setActiveItem() {
    if (
      this.selectedHitIndex >= 0 &&
      this.selectedHitIndex < this.resultItems.length &&
      this.resultItems[this.selectedHitIndex]
    ) {
      this.resultItems[this.selectedHitIndex].classList.add('active');
    }
  }

  handleClickOutside(event) {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      this.clearSearch();
    }
  }

  allowedAccess() {
    return (
      this.allowedShows ||
      this.allowedMovies ||
      this.allowedActors ||
      this.allowedNetworks
    );
  }

  handleChange = event => {
    if (this.allowedAccess()) {
      this.setState({ currentSearch: event.target.value });
      this.resultItems = document.getElementsByClassName(
        'tvt-header__search-bar-results__result-item'
      );
      each(this.resultItems, elem => elem.classList.remove('active'));
      this.selectedHitIndex = -1;
    }
  };

  handleSubmit = event => {
    event.preventDefault();
    // if (
    //   this.selectedHitIndex >= 0 &&
    //   this.selectedHitIndex < this.resultItems.length
    // ) {
    //   this.resultItems[this.selectedHitIndex].click();
    // } else if (this.selectedHitIndex === -1 && this.resultItems.length > 0) {
    //   this.resultItems[0].click();
    // }

    this.props.history.push({
      pathname: '/search-results',
      search: `?query=${this.state.currentSearch}`,
      state: { query: this.state.currentSearch }
    });
    this.clearSearch();
  };

  handleKeyDown = event => {
    if (event.keyCode === 38) {
      this.clearActiveItem();
      if (this.selectedHitIndex > 0) {
        this.selectedHitIndex -= 1;
      }
      this.setActiveItem();
    } else if (event.keyCode === 40) {
      this.clearActiveItem();
      if (this.selectedHitIndex < this.resultItems.length - 1) {
        this.selectedHitIndex += 1;
      }
      this.setActiveItem();
    }
  };

  clearActiveItem() {
    if (
      this.selectedHitIndex >= 0 &&
      this.selectedHitIndex < this.resultItems.length &&
      this.resultItems[this.selectedHitIndex]
    ) {
      this.resultItems[this.selectedHitIndex].classList.remove('active');
    }
  }

  clearSearch() {
    this.setState(() => ({ currentSearch: '' }));
  }

  findActiveItem(itemId) {
    each(this.resultItems, (item, index) => {
      item.classList.remove('active');
      if (item.id === itemId) {
        this.selectedHitIndex = index;
      }
    });
    // this.setActiveItem();
  }

  formatSearchPlaceholder() {
    let allowedAccess = [
      this.allowedShows ? 'show' : '',
      this.allowedMovies ? 'movie' : '',
      this.allowedActors ? 'actor' : '',
      this.allowedNetworks ? 'originating network' : ''
    ];
    allowedAccess = allowedAccess.filter(f => f !== '').join(', ');
    return this.allowedAccess() ? `Search by ${allowedAccess}...` : 'Search';
  }

  render() {
    const resultStyles =
      this.state.currentSearch === ''
        ? 'tvt-header__search-bar-results tvt-header__search-bar-results--no-query'
        : 'tvt-header__search-bar-results';

    return (
      <div className="tvt-header__search-bar" ref={this.setWrapperRef}>
        <InstantSearch
          appId="tvshowtime"
          apiKey={process.env.REACT_APP_ALGOLIA_SEARCH_ONLY_KEY}
          indexName={process.env.REACT_APP_ALGOLIA_SHOW_INDEX}
          root={{
            Root: 'div',
            props: {
              style: {
                flex: 1,
                position: 'relative'
              }
            }
          }}
        >
          <span className="tvt-header__search-bar-icon">
            <i className="fa fa-search" />
          </span>
          <CustomSearchBox
            translations={{
              placeholder: this.formatSearchPlaceholder()
            }}
            onSubmit={this.handleSubmit}
            onChange={this.handleChange}
            onKeyDown={this.handleKeyDown}
            clearSearch={this.state.currentSearch === ''}
            currentRefinement={this.state.currentSearch}
          />
          <div className={resultStyles}>
            <Configure hitsPerPage={4} />
            {this.allowedShows ? (
              <Index indexName={process.env.REACT_APP_ALGOLIA_SHOW_INDEX}>
                <IndexResults className="search-dropdown__results-section">
                  <i className="fa fa-tv search-section__icon" />
                  <Hits
                    hitComponent={({ hit }) => (
                      <Show
                        hit={hit}
                        onSelect={this.clearSearch}
                        onMouseEnter={() =>
                          this.findActiveItem(`show-${hit.id}`)
                        }
                        className={{
                          active: `/show/${hit.id}` === this.selectedHitIndex
                        }}
                      />
                    )}
                  />
                </IndexResults>
              </Index>
            ) : null}
            {this.allowedMovies ? (
              <Index indexName={process.env.REACT_APP_ALGOLIA_MOVIE_INDEX}>
                <IndexResults className="search-dropdown__results-section">
                  <i className="fa fa-film search-section__icon" />
                  <Hits
                    hitComponent={({ hit }) => (
                      <Movie
                        hit={hit}
                        onSelect={this.clearSearch}
                        onMouseEnter={() =>
                          this.findActiveItem(`movie-${hit.MOVIE_TVT_UUID}`)
                        }
                        className={{
                          active:
                            `/movie/${hit.MOVIE_TVT_UUID}` ===
                            this.selectedHitIndex
                        }}
                      />
                    )}
                  />
                </IndexResults>
              </Index>
            ) : null}
            {this.allowedNetworks ? (
              <Index
                indexName={process.env.REACT_APP_ALGOLIA_NETWORK_INDEX}
                className="search-dropdown__results-section"
              >
                <IndexResults>
                  <i className="fa fa-video-camera search-section__icon" />
                  <Hits
                    hitComponent={({ hit }) => (
                      <Network
                        hit={hit}
                        onSelect={this.clearSearch}
                        onMouseEnter={() =>
                          this.findActiveItem(`network-${hit['company_id']}`)
                        }
                        className={{
                          active:
                            `/network/${hit['company_id']}` ===
                            this.selectedHitIndex
                        }}
                      />
                    )}
                  />
                </IndexResults>
              </Index>
            ) : null}
            {this.allowedActors ? (
              <Index
                indexName={process.env.REACT_APP_ALGOLIA_ACTOR_INDEX}
                className="search-dropdown__results-section"
              >
                <IndexResults>
                  <i className="fa fa-user search-section__icon" />
                  <Hits
                    hitComponent={({ hit }) => (
                      <Actor
                        hit={hit}
                        onSelect={this.clearSearch}
                        onMouseEnter={() =>
                          this.findActiveItem(`actor-${hit.id}`)
                        }
                        className={{
                          active: `/actor/${hit.id}` === this.selectedHitIndex
                        }}
                      />
                    )}
                  />
                </IndexResults>
              </Index>
            ) : null}
          </div>
        </InstantSearch>
      </div>
    );
  }
}

SearchBar.propTypes = {
  allowedPages: PropTypes.arrayOf(PropTypes.string).isRequired
};

export default SearchBar;
